"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.api = void 0;
var util = require("./util");
var api;
(function (api) {
    api.uri_prefix = "";
    api.uri_file_catalana = "api/files";
    api.uri_file = "api/files";
    api.uri_util = "api/imposition";
    api.uri_sys_dir = "api/sys/dir";
    function auth_token(data) {
        return post(api.uri_prefix + "api/auth/token", data);
    }
    api.auth_token = auth_token;
    // アップロード
    function upload_file(accessToken, form) {
        return postForm(api.uri_prefix + api.uri_file_catalana, form, accessToken);
    }
    api.upload_file = upload_file;
    // ダウンロード
    function download_file(accessToken, file_key) {
        return getfile(getUrlPrefix(file_key), accessToken);
    }
    api.download_file = download_file;
    // プレビュー
    function preview_file(accessToken, file_key) {
        return getfile(getUrlPrefix(file_key) + "/preview", accessToken);
    }
    api.preview_file = preview_file;
    // プロパティ
    function property(accessToken, file_key, name, sub_type) {
        return put(getUrlPrefix(file_key) + "/property", { name: name, sub_type: sub_type }, accessToken);
    }
    api.property = property;
    // コピー
    function copy(accessToken, src_file_key, name, sub_type) {
        return post(api.uri_prefix + api.uri_file_catalana + "/copy", {
            src_file_key: src_file_key, name: name, sub_type: sub_type
        }, accessToken);
    }
    api.copy = copy;
    // ファイル削除
    function delete_file(accessToken, file_key) {
        return del(api.uri_prefix + api.uri_file_catalana + "/" + file_key, accessToken);
    }
    api.delete_file = delete_file;
    // ファイル件数
    function fileLength(mimes, name, subs, accessToken) {
        var params = mimes.map(function (m) { return "mimes=" + m; }).join("&");
        if (subs.length > 0)
            params += subs.map(function (m) { return "&subs=" + encodeURIComponent(m); }).join("&");
        if (name)
            params += "&name=" + encodeURIComponent(name);
        return get(api.uri_prefix + api.uri_file_catalana + "/length?" + params, accessToken);
    }
    api.fileLength = fileLength;
    function files(mimes, name, subs, index, count, accessToken) {
        var params = mimes.map(function (m) { return "mimes=" + m; }).join("&");
        if (subs.length > 0)
            params += subs.map(function (m) { return "&subs=" + encodeURIComponent(m); }).join("&");
        if (name)
            params += "&name=" + encodeURIComponent(name);
        params += "&index=" + index.toString();
        params += "&count=" + count.toString();
        return get(api.uri_prefix + api.uri_file_catalana + "?" + params, accessToken);
    }
    api.files = files;
    // リフレッシュ（for DevelopProvider）
    function reflesh(accessToken) {
        return get(api.uri_prefix + api.uri_file_catalana + "/refresh", accessToken);
    }
    api.reflesh = reflesh;
    function dir_options(accessToken) {
        return post(api.uri_prefix + api.uri_sys_dir + "/options", {}, accessToken);
    }
    api.dir_options = dir_options;
    function dir_list(accessToken, data) {
        return post(api.uri_prefix + api.uri_sys_dir + "/list", data, accessToken);
    }
    api.dir_list = dir_list;
    function dir_create(accessToken, data) {
        return post(api.uri_prefix + api.uri_sys_dir + "/create", data, accessToken);
    }
    api.dir_create = dir_create;
    // システムフォルダ(ファイル) 削除
    function dir_delete(accessToken, data) {
        return post(api.uri_prefix + api.uri_sys_dir + "/delete", data, accessToken);
    }
    api.dir_delete = dir_delete;
    function dir_download(accessToken, data) {
        return post(api.uri_prefix + api.uri_sys_dir + "/download", data, accessToken, "blob");
    }
    api.dir_download = dir_download;
    function dir_rename(accessToken, data) {
        return post(api.uri_prefix + api.uri_sys_dir + "/rename", data, accessToken);
    }
    api.dir_rename = dir_rename;
    // システムフォルダ(ファイル) ダウンロード
    function dir_upload(accessToken, form) {
        return postForm(api.uri_prefix + api.uri_sys_dir + "/upload", form, accessToken);
    }
    api.dir_upload = dir_upload;
    function get(url, accessToken, restype) {
        if (accessToken === void 0) { accessToken = ""; }
        if (restype === void 0) { restype = "json"; }
        return new Promise(function (resolve, reject) {
            util.ajax.get(url, createHeaders(accessToken), restype, ajaxSuccessFunc(resolve), ajaxErrorFunc(reject), ajaxErrorFunc(reject), ajaxErrorFunc(reject));
        });
    }
    function post(url, param, accessToken, restype) {
        if (accessToken === void 0) { accessToken = ""; }
        if (restype === void 0) { restype = "json"; }
        return new Promise(function (resolve, reject) {
            util.ajax.post(url, createHeaders(accessToken), JSON.stringify(param), restype, ajaxSuccessFunc(resolve), ajaxErrorFunc(reject), ajaxErrorFunc(reject), ajaxErrorFunc(reject));
        });
    }
    function put(url, param, accessToken, restype) {
        if (accessToken === void 0) { accessToken = ""; }
        if (restype === void 0) { restype = "json"; }
        return new Promise(function (resolve, reject) {
            util.ajax.put(url, createHeaders(accessToken), JSON.stringify(param), restype, ajaxSuccessFunc(resolve), ajaxErrorFunc(reject), ajaxErrorFunc(reject), ajaxErrorFunc(reject));
        });
    }
    function postForm(url, form, accessToken, restype) {
        if (accessToken === void 0) { accessToken = ""; }
        if (restype === void 0) { restype = "json"; }
        return new Promise(function (resolve, reject) {
            util.ajax.post(url, createHeaders(accessToken), form, restype, ajaxSuccessFunc(resolve), ajaxErrorFunc(reject), ajaxErrorFunc(reject), ajaxErrorFunc(reject), true);
        });
    }
    function del(url, accessToken, restype) {
        if (accessToken === void 0) { accessToken = ""; }
        if (restype === void 0) { restype = "json"; }
        return new Promise(function (resolve, reject) {
            util.ajax.del(url, createHeaders(accessToken), JSON.stringify({}), restype, ajaxSuccessFunc(resolve), ajaxErrorFunc(reject), ajaxErrorFunc(reject), ajaxErrorFunc(reject));
        });
    }
    function getfile(url, accessToken) {
        if (accessToken === void 0) { accessToken = ""; }
        return new Promise(function (resolve, reject) {
            var req = new XMLHttpRequest();
            req.open('GET', url, true);
            req.responseType = 'blob';
            if (accessToken)
                req.setRequestHeader("Authorization", "Bearer " + accessToken);
            req.onreadystatechange = function () {
                util.ajax.finishProc(req, function () { resolve(req.response); }, ajaxErrorFunc(reject), ajaxErrorFunc(reject), ajaxErrorFunc(reject), ajaxErrorFunc(reject));
            };
            req.onerror = function (e) {
                reject(e);
            };
            req.send();
        });
    }
    /**
     * URLプレフィックス取得
     * @param fileKey ファイルキー
     */
    function getUrlPrefix(fileKey) {
        return api.uri_prefix + api.uri_file_catalana + "/{file_key}".replace("{file_key}", fileKey);
    }
    function createHeaders(accessToken, editToken, uniqueId) {
        if (accessToken === void 0) { accessToken = ""; }
        if (editToken === void 0) { editToken = ""; }
        if (uniqueId === void 0) { uniqueId = ""; }
        var headers = [];
        if (accessToken != "")
            headers.push({ key: "Authorization", value: "Bearer " + accessToken });
        if (editToken != "")
            headers.push({ key: "BpEditToken", value: editToken });
        if (uniqueId != "")
            headers.push({ key: "edit-unique-id", value: uniqueId });
        return headers;
    }
    function ajaxSuccessFunc(f_resolve) {
        return function (req, res) {
            f_resolve({ req: req, res: res, uniqueId: util.js.getReqHeader(req, "edit-unique-id") });
        };
    }
    api.ajaxSuccessFunc = ajaxSuccessFunc;
    function ajaxErrorFunc(f_reject) {
        return function (req) {
            getApiErrorObject(req).then(function (res) {
                var e = new apiError("api error (" + req.status + ")");
                e.response = res;
                e.responseCode = req.status;
                f_reject(e);
            });
        };
    }
    api.ajaxErrorFunc = ajaxErrorFunc;
    function getApiErrorObject(req) {
        return new Promise(function (resolve, reject) {
            if (req.response) {
                var cname = util.js.getName(req.response);
                if (typeof req.response === 'string') {
                    resolve(JSON.parse(req.response));
                }
                else if (cname == 'Blob') {
                    var fr = new FileReader();
                    fr.onload = function () {
                        var p = JSON.parse(this.result);
                        if (typeof p === 'string') {
                            resolve(JSON.parse(p));
                        }
                        else {
                            resolve(p);
                        }
                    };
                    fr.readAsText(req.response);
                }
                else {
                    resolve(req.response);
                }
            }
            else {
                resolve(null);
            }
        });
    }
    var apiError = /** @class */ (function (_super) {
        __extends(apiError, _super);
        function apiError() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return apiError;
    }(TypeError));
    api.apiError = apiError;
})(api = exports.api || (exports.api = {}));
